import classNames from 'classnames';
import React from 'react';
import { XIcon } from '../../../design/assets/tone/x.icon';
import { IconButton } from '../icon-button/icon-button';
import styles from './close-button.module.css';
export function CloseButton(_a) {
    var _b;
    var _c = _a.sticky, sticky = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 20 : _d, onClick = _a.onClick;
    return (React.createElement("div", { className: classNames(styles.closeButtonWrapper, (_b = {}, _b[styles.sticky] = sticky, _b), "kplr_closeButtonWrapper") },
        React.createElement(IconButton, { className: styles.closeButtonIconButton, iconType: "fill", onClick: onClick },
            React.createElement(XIcon, { size: size }))));
}
export default CloseButton;
